import React from 'react';
import { MenuButtonStyle } from './MenuButton.styles';
import { EllipsisVertical } from 'lucide-react';

interface MenuButtonProps {
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

export const MenuButton: React.FC<MenuButtonProps> = ({ onClick }) => (
  <MenuButtonStyle
    onClick={onClick}
    aria-label="Rename">
    <EllipsisVertical size={18} strokeWidth={2.5} />
  </MenuButtonStyle>
);